import Vue from 'vue';

Vue.config.productionTip = false;
let base = window.baseUrl;
let baseUserDefined = false;
let debug = process.env.NODE_ENV !== 'production';

if (debug) {
  base = 'https://centix-dev.nl/';
  window.baseUrl = base;
} else {
  // eslint-disable-next-line
  __webpack_public_path__ = `${base}/NodeJS/dist/`;
}

export default {
  baseuri: base,
  debug: debug,
  setBaseUri (newbase) {
    this.baseuri = newbase;
  },
  get getBase() {
    if (baseUserDefined) {
      if (base) {
        return base;
      }
    }
    if (window.baseUrl && window.baseUrl.length > 0) {
      base = window.baseUrl;
    } else {
      base = '/';
    }
    return base;
  },
  get isDebug () {
    return debug;
  }
};

window.vueSetDebug = function (value) {
  debug = value;
  return 'debugging: ' + debug;
};

window.vueSetBaseUri = function (value) {
  baseUserDefined = true;
  base = value;
  return 'new base uri: ' + base;
};
